import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { withTranslation, Trans } from 'react-i18next';
import * as Sentry from '@sentry/browser';

import styles from './ErrorBoundary.module.scss';
import { MERCHANT_FAQ_URL, SUPPORT_EMAIL_AU, SUPPORT_EMAIL_SG } from '../utils/constants';

const { Text, Title } = Typography;

class ErrorBoundaryRaw extends React.Component {
  state = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  }

  render() {
    const email = process.env.REACT_APP_REGION === 'AU' ? SUPPORT_EMAIL_AU : SUPPORT_EMAIL_SG;
    const messageLink = MERCHANT_FAQ_URL;
    if (this.state.hasError) {
      if (this.state.error?.name === 'noOutlets') {
        return (
          <div className={styles.error} data-testid="no-outlet-error">
            <div className={styles.error__wrapper}>
              <Title>{this.props.t('errorBoundary.noOutletAccess.title')}</Title>
              <Text level={3}>
                <Trans i18nKey="errorBoundary.noOutletAccess.message" values={{ email }}>
                  <a href={messageLink} target="_blank" rel="noopener noreferrer" />
                  <a href={`mailto:${email}`} />
                </Trans>
              </Text>
              <br />
            </div>
          </div>
        );
      }
      return (
        <div className={styles.error}>
          <div className={styles.error__wrapper}>
            <Title>{this.props.t('errorBoundary.title')}</Title>
            <Text level={3}>{this.props.t('errorBoundary.message')}</Text>
            <br />
            <Text>
              <a href="/overview">{this.props.t('errorBoundary.cta')}</a>
            </Text>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundaryRaw.defaultProps = {
  children: null,
};

ErrorBoundaryRaw.propTypes = {
  t: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

const ErrorBoundary = withTranslation()(ErrorBoundaryRaw);

export { ErrorBoundary as default, ErrorBoundaryRaw };
